import React from "react";

const VibeCodingTanpaCoding: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Duel in Vibe Coding merupakan kompetisi pemrograman kreatif yang
        mendorong peserta untuk menciptakan aplikasi atau game digital berbasis{" "}
        <a
          href="https://www.ibm.com/think/topics/artificial-intelligence"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          kecerdasan buatan (Artificial Intelligence)
        </a>
        . Kompetisi ini hadir sebagai respons terhadap pesatnya perkembangan
        teknologi AI yang kini berperan penting dalam proses pengembangan produk
        digital. AI tidak hanya digunakan untuk analisis data, tetapi juga
        sebagai asisten dalam membangun website, aplikasi, dan game interaktif
        dengan proses yang lebih cepat, efisien, dan adaptif.
      </p>

      <p>
        Di tengah transformasi digital, kemampuan memanfaatkan AI secara
        kreatif menjadi nilai tambah penting bagi generasi muda. Duel in Vibe
        Coding mengusung pendekatan{" "}
        <a
          href="https://www.ibm.com/id-id/think/topics/vibe-coding?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          vibe coding
        </a>
        , yaitu metode pengembangan aplikasi yang menekankan keseimbangan antara
        fungsi teknologi, kreativitas ide, dan{" "}
        <a
          href="https://www.interaction-design.org/literature/topics/ux-design"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          pengalaman pengguna
        </a>
        . Peserta tidak hanya berfokus pada hasil teknis, tetapi juga pada
        bagaimana aplikasi atau game mampu menghadirkan interaksi yang
        intuitif, menarik, dan relevan dengan kebutuhan pengguna.
      </p>

      <p>
        Melalui kompetisi ini, peserta diajak mengeksplorasi berbagai
        pemanfaatan AI, mulai dari penggunaan AI sebagai asisten coding,
        penerapan logika berbasis data, hingga integrasi model AI untuk
        menciptakan perilaku aplikasi yang dinamis. Pendekatan ini membantu
        peserta memahami bahwa AI bukan sekadar alat otomatisasi, melainkan
        teknologi kolaboratif yang memperluas ruang eksplorasi kreatif dalam
        pengembangan produk digital.
      </p>

      <p>
        Pendekatan serupa terlihat pada{" "}
        <a
          href="https://vibecoding.id/hackathon"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Vibe Coding Hackathon Indonesia
        </a>
        , sebuah kompetisi intensif yang menantang peserta mengembangkan
        aplikasi atau game berbasis AI dalam waktu terbatas. Beragam karya
        digital berhasil dihasilkan, seperti prototipe aplikasi produktivitas
        berbasis AI, game interaktif dengan karakter adaptif, hingga solusi
        digital yang memanfaatkan AI sebagai co-creator. Penilaian tidak hanya
        menitikberatkan pada fungsi teknis, tetapi juga pada inovasi konsep,
        pemanfaatan AI, serta kualitas pengalaman pengguna.
      </p>

      <p>
        Dalam suasana kompetitif yang inspiratif, Duel in Vibe Coding melatih
        peserta untuk berpikir inovatif, adaptif, dan solutif. Peserta
        mengembangkan keterampilan abad ke-21 seperti creative problem
        solving, AI literacy, dan design thinking. Dengan dukungan ekosistem
        pembelajaran dari{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , kompetisi ini menjadi sarana pembelajaran aplikatif yang
        mempersiapkan generasi muda menghadapi masa depan pengembangan aplikasi
        dan game berbasis kecerdasan buatan.
      </p>
    </div>
  );
};

export default VibeCodingTanpaCoding;
